"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OWClaimLogToJSON = exports.OWClaimLogFromJSONTyped = exports.OWClaimLogFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function OWClaimLogFromJSON(json) {
    return OWClaimLogFromJSONTyped(json, false);
}
exports.OWClaimLogFromJSON = OWClaimLogFromJSON;
function OWClaimLogFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'target': json['target'],
        'date': json['date'],
        'amountReceived': json['amountReceived'],
        'rewardType': !(0, runtime_1.exists)(json, 'rewardType') ? undefined : (0, _1.RewardTypeFromJSON)(json['rewardType']),
    };
}
exports.OWClaimLogFromJSONTyped = OWClaimLogFromJSONTyped;
function OWClaimLogToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'target': value.target,
        'date': value.date,
        'amountReceived': value.amountReceived,
        'rewardType': (0, _1.RewardTypeToJSON)(value.rewardType),
    };
}
exports.OWClaimLogToJSON = OWClaimLogToJSON;
